import type { IErrorResponse, SignInOTPRequest } from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { useTranslation } from '@/hooks';
import { urls } from '@/statics';
import { api, standaloneToast } from '@/utils';

const useSignInOtp = (): UseMutationResult<
  [],
  IErrorResponse,
  SignInOTPRequest
> => {
  const { t } = useTranslation('messages');

  return useMutation({
    mutationFn: (data) => api.post(urls.signInOtp, data),
    onSuccess() {
      standaloneToast({
        status: 'success',
        title: t('sendToCode'),
      });
    },
  });
};

export default useSignInOtp;
